function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React from "react";
import PropTypes from "prop-types";
import { jsx as ___EmotionJSX } from "@emotion/core";

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "13o7eu2",
  styles: "display:block;"
} : {
  name: "13o7eu2",
  styles: "display:block;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9pY29ucy93YXJuaW5nLW9yLXNpZ25pZmljYW50LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1NIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9pY29ucy93YXJuaW5nLW9yLXNpZ25pZmljYW50LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuXG5mdW5jdGlvbiBXYXJuaW5nT3JTaWduaWZpY2FudCh7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0xNiA2YTEuOSAxLjkgMCAwMTEuMzQ5LjU1OWw4LjA5MiA4LjA5MmExLjkwNiAxLjkwNiAwIDAxMCAyLjY5OGwtOC4wOTIgOC4wOTJhMS45MDQgMS45MDQgMCAwMS0yLjY5OCAwbC04LjA5Mi04LjA5MmExLjkwNiAxLjkwNiAwIDAxMC0yLjY5OGw4LjA5Mi04LjA5MkExLjkgMS45IDAgMDExNiA2em0wIDJoLS4wMDJMOCAxNmw4IDggOC04LTgtOHptMCAxMC41YTEgMSAwIDAxLjExNyAxLjk5M0wxNiAyMC41YTEgMSAwIDExMC0yem0uMDU4LTcuNWMuNTIxIDAgLjk0Mi40MjIuOTQyLjk0M3Y1LjExNWMwIC41Mi0uNDIxLjk0Mi0uOTQyLjk0MmgtLjExNWEuOTQzLjk0MyAwIDAxLS45NDMtLjk0MnYtNS4xMTVjMC0uNTIxLjQyMi0uOTQzLjk0My0uOTQzelwiXG4gICAgICAgIGZpbGxSdWxlPVwiZXZlbm9kZFwiXG4gICAgICAgIGZpbGw9e3ByaW1hcnlDb2xvcn1cbiAgICAgIC8+XG4gICAgPC9zdmc+XG4gICk7XG59XG5cbldhcm5pbmdPclNpZ25pZmljYW50LnByb3BUeXBlcyA9IHtcbiAgc2l6ZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBwcmltYXJ5Q29sb3I6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgdGVzdElkOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgV2FybmluZ09yU2lnbmlmaWNhbnQ7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

function WarningOrSignificant(_ref) {
  var size = _ref.size,
      primaryColor = _ref.primaryColor,
      testId = _ref.testId;
  return ___EmotionJSX("svg", {
    css: _ref2,
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    focusable: "false",
    role: "img",
    "data-testid": testId
  }, ___EmotionJSX("path", {
    d: "M16 6a1.9 1.9 0 011.349.559l8.092 8.092a1.906 1.906 0 010 2.698l-8.092 8.092a1.904 1.904 0 01-2.698 0l-8.092-8.092a1.906 1.906 0 010-2.698l8.092-8.092A1.9 1.9 0 0116 6zm0 2h-.002L8 16l8 8 8-8-8-8zm0 10.5a1 1 0 01.117 1.993L16 20.5a1 1 0 110-2zm.058-7.5c.521 0 .942.422.942.943v5.115c0 .52-.421.942-.942.942h-.115a.943.943 0 01-.943-.942v-5.115c0-.521.422-.943.943-.943z",
    fillRule: "evenodd",
    fill: primaryColor
  }));
}

WarningOrSignificant.propTypes = {
  size: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  testId: PropTypes.string
};
export default WarningOrSignificant;